var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M2 12a1.25 1.25 0 0 0 1.25 1.25h7.292a.21.21 0 0 1 .208.208v7.292a1.25 1.25 0 0 0 2.5 0v-7.292a.21.21 0 0 1 .208-.208h7.292a1.25 1.25 0 0 0 0-2.5h-7.292a.21.21 0 0 1-.208-.208V3.25a1.25 1.25 0 0 0-2.5 0v7.292a.21.21 0 0 1-.208.208H3.25A1.25 1.25 0 0 0 2 12"
  })));
};
export default SvgPlus;